import React from "react";
import { ASSETS } from "@/lib/assets";

export function OtmLogo({ className = "", imgClassName = "h-9" }) {
  return (
    <div className={`flex flex-col leading-none ${className}`} data-testid="otm-logo">
      <img src={ASSETS.logo} alt="On The Move" className={`${imgClassName} w-auto object-contain object-left`} />
    </div>
  );
}
